import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_MONITOR } from 'new/constants/pathnames';

export default {
  path: `${ROUTE_REDESIGN}${ROUTE_MONITOR}/error-data-settings`,
  domain: 'monitor',
  header: {
    title: 'Error Data Settings',
    slugTitle: 'Error Data Settings',
  },
  screenName: 'ErrorDataSettings',
};
